<template>
  <div class="coupon-plan-card-parts">
    <div class="coupon-plan-card-parts__detail">
      <h5 class="coupon-plan-card-parts__title">{{ plan.couponData.couponName[$i18n.locale] }}</h5>
      <p class="coupon-plan-card-parts__sub-title">
        {{ plan.couponData.title[$i18n.locale] }}
      </p>
      <p class="coupon-plan-card-parts__description">
        {{ plan.couponData.description[$i18n.locale] }}
      </p>
      <p
        :class="[
          isOneTimePassUsed
            ? 'coupon-plan-card-parts__one-time-pass-term'
            : 'coupon-plan-card-parts__free-plan-term',
        ]"
      >
        {{ plan.couponData.couponApplicationPeriodText }}
      </p>
    </div>
    <p class="coupon-plan-card-parts__price">
      <span class="coupon-plan-card-parts__price__value">{{ priceJpy }}</span>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api'
import ContractPlanDocument from '@/store/stores/collectionModule/documents/plan/ContractPlanDocument'
import I18n from '@/locales/I18n'

/**
 * クーポン用プランカード
 */
export default defineComponent({
  name: 'CouponPlanCardParts',
  props: {
    /**
     * 表示するプラン
     */
    plan: {
      type: Object as PropType<ContractPlanDocument>,
      required: true,
    },
    /**
     * お得額
     */
    bargainPriced: {
      type: String,
      default: '',
    },
    /**
     * 確認画面かどうか
     */
    isConfirmed: {
      type: Boolean,
      default: false,
    },
    /**
     * ワイタイムパスかどうか
     */
    isOneTimePassUsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    /** 金額の単位（現状は円のみ） */
    const planPriceUnit = I18n.tc('SignupPage.SelectPlanPage.plan.priceUnit')

    /** 表示する金額（円） */
    const priceJpy = computed(() => `${props.plan.price?.JPY.toLocaleString()}${planPriceUnit}`)

    return {
      priceJpy,
    }
  },
})
</script>

<style lang="scss" scoped>
.coupon-plan-card-parts {
  display: flex;
  gap: 6px;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  @include fontSetTextMedium(12);

  font-family: $fontSignup;
  letter-spacing: 0.02em;
  font-feature-settings: 'palt' on;

  &__detail {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    gap: 4px;
    text-align: left;
  }

  &__one-time-pass-term,
  &__free-plan-term,
  &__description {
    font-weight: 500;
    font-size: 11px;
    line-height: 1.45;
    color: $gray75;
  }

  &__free-plan-term {
    color: $red;
  }

  &__description {
    font-weight: 500;
    font-size: 11px;
    line-height: 1.45;
    color: $gray75;
    white-space: pre-line;
  }

  &__title {
    font-weight: 700;
    font-size: 16px;
    color: $black;

    @media screen and (max-width: 350px) {
      font-size: 14px;
    }
  }

  &__sub-title {
    font-size: 12px;
    font-weight: 500;

    @media screen and (max-width: 350px) {
      font-size: 11px;
    }
  }

  &__price {
    display: flex;
    flex-flow: column nowrap;
    gap: 2px;
    text-align: right;

    &__value {
      font-weight: 700;
      font-size: 16px;
      color: $black;
      white-space: nowrap;

      @media screen and (max-width: 350px) {
        font-size: 14px;
      }
    }
  }
}
</style>
